import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
class CargoDatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDate: moment(this.props.initialDate).toDate(),
        };
    }
    onDatePickerChange(selectedString) {
        const selectedDate = moment(selectedString).toDate();
        this.props.onChange(selectedDate);
        this.setState({ selectedDate });
    }
    isDateValid(selectedDate) {
        return !(!selectedDate || selectedDate.toString() === 'Invalid Date');
    }
    render() {
        return (React.createElement(FormGroup, null,
            React.createElement(ControlLabel, null, this.props.label),
            React.createElement(DatePicker, { selected: this.isDateValid(this.state.selectedDate)
                    ? moment(this.state.selectedDate)
                    : null, onChange: (selectedString) => this.onDatePickerChange(selectedString), className: "mt-4 form-field", dateFormat: "L", locale: this.props.locale, maxDate: this.props.maxDate })));
    }
}
CargoDatePicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    initialDate: PropTypes.object,
    maxDate: PropTypes.object,
    label: PropTypes.string.isRequired,
};
CargoDatePicker.defaultProps = {
    initialDate: new Date(),
    maxDate: new Date(),
};
export default CargoDatePicker;
